

import { DRAWER_MENU_OPTIONS } from "../types";

export const setSelectedDrawerOptionsMenu = (selectDrawerMenu: any) => {
  return {
    type: DRAWER_MENU_OPTIONS.DRAWER_MENU_OPTIONS_SET_SELECTED,
    payload: {...selectDrawerMenu}
  }
}

export const clearSelectedDrawerOptionsMenu = () => {
  return {
    type: DRAWER_MENU_OPTIONS.DRAWER_MENU_OPTIONS_CLEAR_SELECTED
  }
}